import { createRouter, createWebHistory } from 'vue-router'

export const router = createRouter({
  history: createWebHistory(),
  routes: [
    { path: '/', name: 'Home', component: () => import('@/pages/Home'), meta: { title: 'UMAI' } },
    { path: '/login', name: 'Login', component: () => import('@/pages/Login'), meta: { title: 'Вход' } },
    { path: '/register', name: 'Register', component: () => import('@/pages/Register'), meta: { title: 'Регистрация' } },
    { path: '/reset-password', name: 'ResetPassword', component: () => import('@/pages/ResetPassword'), meta: { title: 'Сброс пароля' } },
    { path: '/my-requests', name: 'MyRequests', component: () => import('@/pages/MyRequests'), meta: { title: 'Мои заявки' } },
    { path: '/payments', name: 'Payments', component: () => import('@/pages/Payments'), meta: { title: 'Платежи' } },
    { path: '/dealercash', name: 'Dealercash', component: () => import('@/pages/DealerCash'), meta: { title: 'Остатки у дилера' } },
    { path: '/encashments', name: 'Encashments', component: () => import('@/pages/Encashments'), meta: { title: 'Инкассация' } },
    { path: '/terminalcash', name: 'Terminalcash', component: () => import('@/pages/TerminalCash'), meta: { title: 'Остатки в терминалах' } },
    { path: '/dealerpayments', name: 'Dealerpayments', component: () => import('@/pages/DealerPayments'), meta: { title: 'Дилеры' } },
    { path: '/terminalpayments', name: 'Terminalpayments', component: () => import('@/pages/TerminalPayments'), meta: { title: 'Терминалы' } },
    { path: '/supplierpayments', name: 'Supplierpayments', component: () => import('@/pages/SupplierPayments'), meta: { title: 'Поставщики' } },
    { path: '/servicegroups', name: 'Servicegroups', component: () => import('@/pages/ServiceGroups'), meta: { title: 'Категории' } },
    { path: '/suppliers', name: 'Suppliers', component: () => import('@/pages/Suppliers'), meta: { title: 'Поставщики' } },
    { path: '/services', name: 'Services', component: () => import('@/pages/Services'), meta: { title: 'Сервисы' } },
    { path: '/dealerservices', name: 'DealerServices', component: () => import('@/pages/DealerServices'), meta: { title: 'Сервисы дилера' } },
    { path: '/users', name: 'Users', component: () => import('@/pages/Users') },
    { path: '/banks', name: 'Partners', component: () => import('@/pages/Partners'), meta: { title: 'Контрагенты' } },
    { path: '/dealers', name: 'Dealers', component: () => import('@/pages/Dealers'), meta: { title: 'Дилеры' } },
    { path: '/profiles', name: 'Profiles', component: () => import('@/pages/Profiles'), meta: { title: 'Анкеты' } },
    { path: '/wallets', name: 'Wallets', component: () => import('@/pages/Wallets'), meta: { title: 'Анкеты UMAI' } },
    { path: '/terminals', name: 'Terminals', component: () => import('@/pages/Terminals'), meta: { title: 'Терминалы' } },
    { path: '/terminalstatus', name: 'TerminalStatus', component: () => import('@/pages/TerminalStatus'), meta: { title: 'Терминалы' } },
    { path: '/encashmentlist', name: 'EncashmentList', component: () => import('@/pages/EncashmentList'), meta: { title: 'Список инкассации' } },
    { path: '/reestrs', name: 'Reestrs', component: () => import('@/pages/Reestrs') },
    { path: '/paymentlogs', name: 'PaymentLogs', component: () => import('@/pages/PaymentLogs'), meta: { title: 'Логи платежей' } },
    { path: '/profile', name: 'Profile', component: () => import('@/pages/Profile'), meta: { title: 'Профиль' } },
    { path: '/roleconfig', name: 'RoleConfig', component: () => import('@/pages/RoleConfig'), meta: { title: 'Настройка ролей' } },
    { path: '/vpn', name: 'VPN', component: () => import('@/pages/VPN'), meta: { title: 'OpenVPN' } },
    { path: '/:pathMatch(.*)*', redirect: '/' }
  ]
});

// Проверка входа перед каждым переходом. Возвращает путь для редиректа или
// true — колбэк next() в vue-router 5 объявлен устаревшим
export function authGuard (to) {
  const publicPages = ['/', '/login', '/register', '/reset-password'];
  const pendingPages = ['/my-requests', '/profile'];
  const authRequired = !publicPages.includes(to.path);
  document.title = to.meta.title ? to.meta.title : 'UMAI';

  if (authRequired) {
    try {
      const raw = localStorage.getItem('user');
      const user = raw ? JSON.parse(raw) : null;
      if (!user) return '/login';

      // Pending-пользователь (нет одобренной роли) — только профиль и заявки
      if (user.pending && !pendingPages.includes(to.path)) {
        return '/my-requests';
      }
    } catch {
      localStorage.removeItem('user');
      return '/login';
    }
  }

  return true;
}

router.beforeEach(authGuard);
